import { render, staticRenderFns } from "./FlightItem.vue?vue&type=template&id=24dd4cb4&scoped=true&"
import script from "./FlightItem.vue?vue&type=script&lang=js&"
export * from "./FlightItem.vue?vue&type=script&lang=js&"
import style0 from "./FlightItem.vue?vue&type=style&index=0&id=24dd4cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd4cb4",
  null
  
)

export default component.exports